import { PDPLoader } from '../types';
import { getDynamicCurrency } from '@/util-conversion/currency';
import { capitalizeOnlyFirstLetter } from '@/util-conversion/misc/capitalize-only-first-letter';
import { kebabCaseToTitleCase } from '@/util-conversion/misc/kebab-case-to-title-case';
import { mileageNoDecimals } from '@/util-conversion/misc/mileage-no-decimals';

export const getPDPPageTitle = (data: PDPLoader) => {
  const model = data?.details?.vehicle?.model;
  const make = data?.details?.vehicle?.make;
  const modelYear = data?.details?.vehicle?.model_year;
  const color = data?.details?.vehicle?.exterior_color_basic
    ? capitalizeOnlyFirstLetter(data?.details?.vehicle?.exterior_color_basic)
    : '';
  const mileage = data?.details?.vehicle?.odometer
    ? `${mileageNoDecimals(data?.details?.vehicle?.odometer)} mi |`
    : '';
  const planCost = data?.details?.vehicle?.plans?.sort(
    (a, b) => a.miles_per_month - b.miles_per_month
  );
  const marketName = data?.details?.vehicle?.market_id
    ? kebabCaseToTitleCase(data?.details?.vehicle?.market_id)
    : '';

  if (!make || !model) {
    return { title: 'Loading... | Car Details' };
  } else {
    return {
      title:
        planCost && planCost[1]
          ? `${modelYear} ${make} ${model} | Starts at ${getDynamicCurrency(planCost[1]?.total_price_per_month ?? 0)}/mo | ${mileage} ${color}`
          : `${modelYear} ${make} ${model} | ${mileage} ${color}`,
      description: marketName
        ? `Greater ${marketName}’s only month-to-month car lease.  Zero down payment. Cancel anytime with no penalty. Ditch the dealership and save thousands with Flexcar.`
        : `Zero down payment. Cancel anytime with no penalty. Ditch the dealership and save thousands with Flexcar.`,
    };
  }
};
